import type React from "react";

type Props = {
  children: React.ReactNode;
};

export const LayoutButtonsCheckout: React.FC<Props> = ({ children }: Props) => {
  return (
    <div className="ps-section__header d-flex justify-content-center align-items-center">
      <div className="d-flex flex-row">{children}</div>
    </div>
  );
};
